import React, { useEffect, useRef, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import { TabContext } from "@mui/lab";
import { TextField } from "@mui/material";

import "./Section.css";
import SuccessAlert from "../components/success-alert/SuccessAlert";
import ErrorAlert from "../components/error-alert/ErrorAlert";
import useLanguages from "../hooks/useLanguages";
import { API, SERVER_DOMAIN } from "../assets/staticData";
import facebookIcon from "../assets/icons/facebook.svg";
import xIcon from "../assets/icons/x.svg";
import instagramIcon from "../assets/icons/instagram.svg";
import linkedinIcon from "../assets/icons/linkedin.svg";
import youtubeIcon from "../assets/icons/youtube.svg";
import telegramIcon from "../assets/icons/telegram.svg";
import ClearCacheButton from "../components/ClearCacheButton/ClearCacheButton";
import { CACHE_KEY } from "../constant/cache-key";

export default function SocialMedia({ user }) {
  const langs = useLanguages();

  const [value, setValue] = useState("0");
  const [data, setData] = useState([]);
  const [errors, setErrors] = useState([]);
  const [success, setSuccess] = useState(false);
  const [fail, setFail] = useState(false);
  const [loading, setLoading] = useState(true);

  let userToken = localStorage.getItem("userToken");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  let tabStyle = { textTransform: "capitalize", fontWeight: "500" };

  // Get Data from backend
  useEffect(() => {
    let docs = langs.map((item) => ({
      facebook: "",
      x: "",
      instagram: "",
      linkedIn: "",
      youtube: "",
      telegram: "",
      telegram2: "",
      whatsapp: "",
      skype: "",
      language: item.attributes.language,
    }));
    setData(docs);
    let errorDocs = [];
    langs.map(() => {
      errorDocs.push({ error: false });
    });
    setErrors(errorDocs);

    async function getData() {
      await fetch(`${API}/social-media`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      }).then(async (res) => {
        const response = await res.json();
        const apiData = response.data?.attributes?.socialMediaData || [];

        setData((prevData) => {
          return prevData.map((localItem) => {
            const apiItem = apiData.find((apiItem) => apiItem.language === localItem.language);

            if (apiItem) {
              return {
                ...localItem,
                facebook: apiItem.facebook || localItem.facebook,
                x: apiItem.x || localItem.x,
                instagram: apiItem.instagram || localItem.instagram,
                linkedIn: apiItem.linkedIn || localItem.linkedIn,
                youtube: apiItem.youtube || localItem.youtube,
                telegram: apiItem.telegram || localItem.telegram,
                telegram2: apiItem.telegram2 || localItem.telegram2,
                whatsapp: apiItem.whatsapp || localItem.whatsapp,
                skype: apiItem.skype || localItem.skype,
              };
            } else {
              return localItem;
            }
          });
        });
        setLoading(false);
      });
    }

    getData();
  }, [langs]);

  const submitData = (item, index) => {
    fetch(`${API}/social-media`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { socialMediaData: data },
      }),
    }).then(async (res) => {
      if (res.ok) {
        setSuccess(true);
      } else {
        setFail(true);
      }
    });
  };

  return (
    <TabContext value={value}>
      <ClearCacheButton keys={[CACHE_KEY.socialMedia]} />

      <Box sx={{ width: "100%" }}>
        <h3 style={{ textTransform: "capitalize" }}>Social Media Settings</h3>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="secondary tabs">
          {langs?.map((item, index) => {
            return (
              <Tab
                key={index}
                sx={tabStyle}
                value={index.toString()}
                label={item.attributes.language}
                icon={
                  <img
                    src={SERVER_DOMAIN + item.attributes.icon.data.attributes.url}
                    style={{ width: 25, aspectRatio: 1, borderRadius: 20 }}
                  />
                }
                iconPosition="start"
              />
            );
          })}
        </Tabs>

        {loading ? (
          <></>
        ) : (
          <>
            {langs?.map((item, index) => {
              return (
                <TabPanel value={index.toString()} key={index}>
                  <SuccessAlert show={success} setShow={(v) => setSuccess(v)} />
                  <ErrorAlert
                    show={fail}
                    setShow={(v) => setFail(v)}
                    message={"No changes were made to the current links"}
                  />
                  <h3 className="mb-3">Social Media Accounts</h3>
                  <div className="socialInputC">
                    <img src={facebookIcon} />
                    <TextField
                      sx={{ width: 350 }}
                      label="Facebook"
                      variant="outlined"
                      size="small"
                      value={data[index]?.facebook || ""}
                      error={errors[index]?.error}
                      onChange={(e) => {
                        setData([
                          ...data.map((item, idx) => {
                            if (idx === index) {
                              return { ...item, facebook: e.target.value };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                        setErrors([
                          ...errors.map((item, idx) => {
                            if (idx === index) {
                              return { ...item, error: false };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                      }}
                    />
                  </div>
                  <div className="socialInputC">
                    <img src={xIcon} />
                    <TextField
                      sx={{ width: 350 }}
                      label="X"
                      variant="outlined"
                      size="small"
                      value={data[index]?.x || ""}
                      error={errors[index]?.error}
                      onChange={(e) => {
                        setData([
                          ...data.map((item, idx) => {
                            if (idx === index) {
                              return { ...item, x: e.target.value };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                        setErrors([
                          ...errors.map((item, idx) => {
                            if (idx === index) {
                              return { ...item, error: false };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                      }}
                    />
                  </div>
                  <div className="socialInputC">
                    <img src={linkedinIcon} />
                    <TextField
                      sx={{ width: 350 }}
                      label="LinkedIn"
                      variant="outlined"
                      size="small"
                      value={data[index]?.linkedIn || ""}
                      error={errors[index]?.error}
                      onChange={(e) => {
                        setData([
                          ...data.map((item, idx) => {
                            if (idx === index) {
                              return { ...item, linkedIn: e.target.value };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                        setErrors([
                          ...errors.map((item, idx) => {
                            if (idx === index) {
                              return { ...item, error: false };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                      }}
                    />
                  </div>
                  <div className="socialInputC">
                    <img src={instagramIcon} />
                    <TextField
                      sx={{ width: 350 }}
                      label="Instagram"
                      variant="outlined"
                      size="small"
                      value={data[index]?.instagram || ""}
                      error={errors[index]?.error}
                      onChange={(e) => {
                        setData([
                          ...data.map((item, idx) => {
                            if (idx === index) {
                              return { ...item, instagram: e.target.value };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                        setErrors([
                          ...errors.map((item, idx) => {
                            if (idx === index) {
                              return { ...item, error: false };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                      }}
                    />
                  </div>
                  <div className="socialInputC">
                    <img src={youtubeIcon} />
                    <TextField
                      sx={{ width: 350 }}
                      label="YouTube"
                      variant="outlined"
                      size="small"
                      value={data[index]?.youtube || ""}
                      error={errors[index]?.error}
                      onChange={(e) => {
                        setData([
                          ...data.map((item, idx) => {
                            if (idx === index) {
                              return { ...item, youtube: e.target.value };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                        setErrors([
                          ...errors.map((item, idx) => {
                            if (idx === index) {
                              return { ...item, error: false };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                      }}
                    />
                  </div>
                  <div className="socialInputC">
                    <img src={telegramIcon} />
                    <TextField
                      sx={{ width: 350 }}
                      label="Telegram"
                      variant="outlined"
                      size="small"
                      value={data[index]?.telegram || ""}
                      error={errors[index]?.error}
                      onChange={(e) => {
                        setData([
                          ...data.map((item, idx) => {
                            if (idx === index) {
                              return { ...item, telegram: e.target.value };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                        setErrors([
                          ...errors.map((item, idx) => {
                            if (idx === index) {
                              return { ...item, error: false };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                      }}
                    />
                  </div>

                  <div className="divider"></div>
                  <h3 className="mb-4">Contact Accounts</h3>

                  <div className="socialInputC">
                    <img src={require("../assets/icons/whatsapp.png")} />
                    <TextField
                      sx={{ width: 350 }}
                      label="WhatsApp"
                      variant="outlined"
                      size="small"
                      value={data[index]?.whatsapp || ""}
                      error={errors[index]?.error}
                      onChange={(e) => {
                        setData([
                          ...data.map((item, idx) => {
                            if (idx === index) {
                              return { ...item, whatsapp: e.target.value };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                        setErrors([
                          ...errors.map((item, idx) => {
                            if (idx === index) {
                              return { ...item, error: false };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                      }}
                    />
                  </div>
                  <div className="socialInputC">
                    <img src={telegramIcon} />
                    <TextField
                      sx={{ width: 350 }}
                      label="Telegram"
                      variant="outlined"
                      size="small"
                      value={data[index]?.telegram2 || ""}
                      error={errors[index]?.error}
                      onChange={(e) => {
                        setData([
                          ...data.map((item, idx) => {
                            if (idx === index) {
                              return { ...item, telegram2: e.target.value };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                      }}
                    />
                  </div>
                  <div className="socialInputC">
                    <img src={require("../assets/icons/skype.png")} />
                    <TextField
                      sx={{ width: 350 }}
                      label="Skype"
                      variant="outlined"
                      size="small"
                      value={data[index]?.skype || ""}
                      error={errors[index]?.error}
                      onChange={(e) => {
                        setData([
                          ...data.map((item, idx) => {
                            if (idx === index) {
                              return { ...item, skype: e.target.value };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                        setErrors([
                          ...errors.map((item, idx) => {
                            if (idx === index) {
                              return { ...item, error: false };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                      }}
                    />
                  </div>

                  {user.perms[4].edit && (
                    <div className="submitBTN" onClick={() => submitData(item, index)}>
                      Save Changes
                    </div>
                  )}
                </TabPanel>
              );
            })}
          </>
        )}
      </Box>
    </TabContext>
  );
}
